export default __webpack_public_path__ + "static/media/close.d784225f.svg";